import React from 'react'
import { Link } from '@inertiajs/react'
import { Box, Typography } from '@mui/material'

interface Props {
  title: string
  action?: React.ReactNode
  viewAllHref?: string
}

export default function SectionHeading({ title, action, viewAllHref }: Props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1 }}>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      {action ?? (viewAllHref && (
        <Typography
          component={Link}
          href={viewAllHref}
          variant="body2"
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            fontWeight: 600,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          View all
        </Typography>
      ))}
    </Box>
  )
}
